import { action, computed, observable, runInAction, toJS } from "mobx";
import { exchanges } from "../api/agent";
import { Exchange } from "../models/exchange-types";
import { Root } from "./store-root";
import * as _ from "lodash";
import { API } from "aws-amplify";

export class ExchangeStore {
  parent: Root;
  @observable exchangesRegitery = new Map();
  @observable exchange: Exchange | undefined = undefined;
  @observable USD_To_ERN : Exchange| undefined= undefined;

  constructor(root: Root) {
    this.parent = root;
  }

  @action loadExchanges = async () => {
    try {
      const fromBackEnd: Exchange[] = await API.get("backend", "/rates", {});

      this.exchangesRegitery.clear();
      //Load  the local registery
      runInAction("loading local exchanges registery", () => {
        fromBackEnd.forEach((item: Exchange) => {
          this.exchangesRegitery.set(item.Id, item);
          if(item.Id=='From_USD_to_ERN') {
            this.USD_To_ERN = item;
          }
        });
      });
    } catch (error) {
      //Todo : notify users with error toast

      runInAction("load agents error", () => {
        console.log("Error loading exchanges :  ", error);
      });
    }
  };

  @action loadExchange = async (id: string) => {
    let fromBackend = this.exchangesRegitery.get(id);
    if (!fromBackend) {
      this.exchange = fromBackend;
      return toJS(fromBackend);
    } else {
      fromBackend = await API.get("backend", `/rates/${id}`, {});
      runInAction(() => {
        this.exchange = fromBackend;
        this.exchangesRegitery.set(fromBackend.id, fromBackend);
      });
      return fromBackend;
    }
  };

  @action createExchangeRate = async (exchange: Exchange) => {
    await API.post("backend", "/rates", {body:exchange});
  };

  @action saveExchangeRate= async(exchange: Exchange)=>{
    await API.put('backend',`/rates/${exchange.Id}`,{body:exchange});
  }


  @computed get exchanges() {
    return _.sortBy(
      Array.from(this.exchangesRegitery.values()),
      (item: Exchange) => item.Id
    );
  }

  @computed get exchangesList(){
    return Array.from(this.exchangesRegitery.values()).map((item:Exchange)=>{return {id:item.Id, label:item.Label}})
  }

  @computed get exchangesAllowedForCurrentUser(){
    console.log('Loaded from db ',this.parent.Users.AllowedExchanges);

    const allowedExchange = Array.from(this.exchangesRegitery.values()).filter(
        (item:Exchange)=>{
          const returned = _.includes(toJS(this.parent.Users.AllowedExchanges),item.Id)
          console.log(returned);
          console.log(item.Id);
          console.log(toJS(this.parent.Users.AllowedExchanges));
          return returned;

        }).map(
            (item:Exchange)=>{return {id:item.Id, label:item.Label}})

    console.log('Allowed Exchanges ', allowedExchange);
    return allowedExchange;
  }
}
